export default {
  namespaced: true,
  state: {
    showModal: {
      show: false,
      id: null,
      type: "",
      groupId: null,
      copyTradeDetail: {},
    },
  },
  getters: {
    getShow: (state) => state.showModal.show,
  },
  mutations: {
    TOGGLE_MODAL(state, obj) {
      if (obj.show) {
        // console.log("KCH",obj.text)
        state.showModal.id = obj.id ? obj.id : null;
        state.showModal.type = obj.type ? obj.type : "";
        state.showModal.groupId = obj.groupId ? obj.groupId : null;
        state.showModal.copyTradeDetail = obj.copyDetail ? obj.copyDetail : {};
      }
      state.showModal.show = obj.show;
    },
  },
  actions: {
    toggleModal({ commit }, obj) {
      commit("TOGGLE_MODAL", obj);
    },
  },
};
